export default "__VITE_ASSET__C5CULX5Y__"